import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-f2feb1ec"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "app-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Modal = _resolveComponent("Modal");

  var _component_Navbar = _resolveComponent("Navbar");

  var _component_el_header = _resolveComponent("el-header");

  var _component_RefreshApp = _resolveComponent("RefreshApp");

  var _component_SalesClosedBanner = _resolveComponent("SalesClosedBanner");

  var _component_AppMain = _resolveComponent("AppMain");

  var _component_Teams = _resolveComponent("Teams");

  var _component_RestoreLogs = _resolveComponent("RestoreLogs");

  var _component_el_main = _resolveComponent("el-main");

  var _component_NewCashFloatOpen = _resolveComponent("NewCashFloatOpen");

  var _component_CloseCashfloat = _resolveComponent("CloseCashfloat");

  var _component_Footer = _resolveComponent("Footer");

  var _component_el_footer = _resolveComponent("el-footer");

  var _component_el_container = _resolveComponent("el-container");

  var _directive_loading = _resolveDirective("loading");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_Modal), _createVNode(_component_el_header, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_Navbar)];
        }),
        _: 1
      }), !_ctx.showCashfloatOpen && !_ctx.showCashfloatClose ? (_openBlock(), _createBlock(_component_el_main, {
        key: 0,
        class: "is-flex is-align-items-stretch"
      }, {
        default: _withCtx(function () {
          return [_ctx.isRefreshing ? (_openBlock(), _createBlock(_component_RefreshApp, {
            key: 0
          })) : _createCommentVNode("", true), !_ctx.hasSalesStarted && _ctx.isUserLoggedIn && _ctx.hasUser ? (_openBlock(), _createBlock(_component_SalesClosedBanner, {
            key: 1
          })) : _createCommentVNode("", true), !_ctx.isRefreshing ? (_openBlock(), _createBlock(_component_AppMain, {
            key: 2,
            class: "app-main"
          })) : _createCommentVNode("", true), _ctx.showTeamsView ? (_openBlock(), _createBlock(_component_Teams, {
            key: 3
          })) : _createCommentVNode("", true), !_ctx.hasSalesStarted && _ctx.isRestoringLogs ? (_openBlock(), _createBlock(_component_RestoreLogs, {
            key: 4
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.showCashfloatOpen ? (_openBlock(), _createBlock(_component_el_main, {
        key: 1,
        class: "is-flex is-align-items-stretch",
        style: {
          "padding": "0px"
        }
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_NewCashFloatOpen)];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.showCashfloatClose ? (_openBlock(), _createBlock(_component_el_main, {
        key: 2,
        class: "is-flex is-align-items-stretch",
        style: {
          "padding": "0px"
        }
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_CloseCashfloat)];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.isAuth && !_ctx.isRefreshing && !_ctx.showCashfloatClose ? (_openBlock(), _createBlock(_component_el_footer, {
        key: 3
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_Footer)];
        }),
        _: 1
      })) : _createCommentVNode("", true)];
    }),
    _: 1
  })), [[_directive_loading, _ctx.isLoading]])]);
}